import React, { useContext, useState } from 'react';
import { Context } from '../../../../config/store';
import LenderUgroService from '../../../../services/lender';
import { downloadFile } from '../../../../common/download';
import { toast } from 'react-toastify';
import message from '../../../../constant/message';
import { Link, useParams } from 'react-router-dom';

export const Download = (props) => {
	const { state } = React.useContext(Context);
	const [loading, setLoading] = React.useState(false);
	const title = props.title;
	const field = props.field;
	const fileId = props.row?.[field];
	const fileName = props.row?.file_name;
	const downloadDoc = async () => {
		setLoading(true);
		try {
			let toastId = toast.warning("Document Downloading, Please wait...")
			let response = await LenderUgroService.downloadFileById({
				type: state.userType,
				fileId,
				responseType: 'blob'
			});
			toast.dismiss(toastId)
			downloadFile(response?.data, fileName.replace(/\.[^/.]+$/, ''))
		} catch (err) {
			toast.error(message.ERROR);
		}
		setLoading(false);
	};
	return fileId ? (
		<span className='link btn' onClick={downloadDoc}>
			{loading ? <div className='loader' /> : title ? title : 'Download'}
		</span>
	) : (
		<span className='mx-4'></span>
	);
};

const AuditActions = (props) => {
	const { state } = useContext(Context);
	const leadId = useParams().id;
	const field = props.field;
	
	const checkHasPermission = (checkPermission) => {
		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	return (
		<>
			<Download
				title={
					<button className='btn btn-custom'
						style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center" }} data-tip>
						<i className='fa fa-download'></i>
					</button>
				}
				{...props}
			/>

		</>
	);
};

export default AuditActions;
